const CRISP_WEBSITE_ID = "1b17f164-ae43-423d-80fc-87e79c55ab20";
let loaded = false;

function loadCrisp() {
    if (loaded || typeof window === "undefined" || typeof document === "undefined") {
        return;
    }

    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

    const script = document.createElement("script");
    script.src = "https://client.crisp.chat/l.js";
    script.async = true;
    document.head.appendChild(script);
    loaded = true;
}

export function identifyCrispUser(user = {}) {
    loadCrisp();
    if (typeof window === "undefined" || !window.$crisp) {
        return;
    }

    const { email } = user;

    if (email && typeof email === "string") {
        window.$crisp.push(["set", "user:email", email]);
    }
}
